"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.generateSizesObjectFromSrcSet = function (srcSet) {
  return srcSet.split(',').map(function (e) {
    return e.split(' ');
  }).reduce(function (acc, e) {
    var _a;

    return __assign(__assign({}, acc), (_a = {}, _a[e[1].split('w')[0]] = e[0].trim(), _a));
  }, {});
};

function createLsgSrcsetFromFluidImage(fluid) {
  if (fluid && fluid.srcSet) {
    var images = exports.generateSizesObjectFromSrcSet(fluid.srcSet);
    var keys = Object.keys(images).map(function (e) {
      return parseInt(e, 10);
    }).sort(function (a, b) {
      return a - b;
    });
    var last = images[keys[keys.length - 1]];
    return {
      "default": images[keys.filter(function (el) {
        return el >= 640;
      })[0]] || last,
      xs: images[keys.filter(function (el) {
        return el >= 640;
      })[0]] || last,
      sm: images[keys.filter(function (el) {
        return el >= 1024;
      })[0]] || last,
      md: images[keys.filter(function (el) {
        return el >= 1196;
      })[0]] || last,
      lg: images[keys.filter(function (el) {
        return el >= 1680;
      })[0]] || last,
      xl: last
    };
  }

  return fluid && fluid.src;
}

exports.createLsgSrcsetFromFluidImage = createLsgSrcsetFromFluidImage;